import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxIcon, OnyxOptional } from '@onyx/angular';
import { OnyxIconComponent } from '@onyx/angular';

@Component({
  selector: 'app-icon-text-tooltip',
  imports: [OnyxIconComponent, TranslatePipe],
  templateUrl: './icon-text-tooltip.component.html',
  styleUrl: './icon-text-tooltip.component.scss',
})
export class IconTextTooltipComponent {
  public readonly icon = input<OnyxOptional<OnyxIcon>>();
  public readonly heading = input.required<string>();
  public readonly description = input<OnyxOptional<string>>();
}
